<template>
  <div class="section-journey__content--buttons">
    <button
      @click="url ? openLink(url) : action()"
      class="site-title__button button-circle"
      :class="{ '-active': active }"
      :style="`border: 1px solid ${theme.color};`"
      @mouseenter="active = true"
      @mouseleave="active = false"
    >
      {{ label }}
    </button>
    <button
      @click="url ? openLink(url) : action()"
      class="site-title__button -round button-circle -sm"
      :class="{ '-active': active }"
      :style="`border: 1px solid ${theme.color}; color: ${theme.color}`"
      @mouseenter="active = true"
      @mouseleave="active = false"
    >
      <Icon id="arrowRight" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'DoubleButton',
  props: {
    action: {
      type: Function,
      default: () => {},
    },
    url: {
      type: String,
      default: null,
    },
    theme: {
      type: Object,
    },
    label: {
      type: String,
    },
  },
  data() {
    return {
      active: false,
    }
  },
  methods: {
    openLink(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },
  },
}
</script>
